export const ADD_VERANSTALTUNG_ALERT_SHOW = 'ADD_VERANSTALTUNG_ALERT_SHOW'
export const ADD_VERANSTALTUNG_ALERT_CLOSE = 'ADD_VERANSTALTUNG_ALERT_CLOSE'
export const DIMISS_HEADER_ALERT = 'DIMISS_HEADER_ALERT'
export const SHOW_HEADER_ALERT = 'SHOW_HEADER_ALERT'

// Action creator
export const addVeranstaltungShowAlert = (message) => {
	return { type: ADD_VERANSTALTUNG_ALERT_SHOW, message}
}
export const dimissHeaderAlert = () => {
	return { type: DIMISS_HEADER_ALERT }
}
export const addVeranstaltungDimissAlert = () => {
	return { type: ADD_VERANSTALTUNG_ALERT_CLOSE}
}
export const showHeaderAlert = (message="no message found", alertColor ="danger") => {
	return { type: SHOW_HEADER_ALERT, payload: { message, alertColor}}
}
